interface Props {
  text: string
}
export const LabelKey: React.FC<Props> = ({ text }) => {
  return (
    <div className="sm:pb-[6px] sm:w-[70px] sm:border-b sm:border-[#e6e6e6] sm:border-dotted">
      <span className="sm:inline-block sm:h-[calc(100%+7px)] text-sm sm:text-base font-medium sm:font-thin sm:border-b sm:border-[#4686ce] sm:border-solid">
        {text}
      </span>
    </div>
  )
}
